module.exports = __webpack_public_path__ + "img/ic_text_increase.f8a7f1b4.svg";